declare global {
  interface Window {
    __PWA_BUILD__?: { version: string };
  }
}

/**
 * Release identity of this PWA bundle, stamped by scripts/build.js.
 * `npm start` has no stamp, so the version reads "dev".
 */
export const WEB_BUILD = {
  version: process.env.REACT_APP_WEB_VERSION || "dev",
  // only used for the Sentry release name; never shown to users
  commit: process.env.REACT_APP_GIT_SHA || "",
};

/** "Web v1.2.0" */
export const getWebBuildLabel = (): string => `Web v${WEB_BUILD.version}`;

/** Sentry release name, so errors are grouped by the PWA release that produced them. */
export const getSentryRelease = (): string | undefined =>
  WEB_BUILD.version === "dev" ? undefined : `pm-doctor-tatva-pwa@${WEB_BUILD.version}+${WEB_BUILD.commit}`;
